import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import ChainedBackend from "i18next-chained-backend";
import HttpBackend from "i18next-http-backend";
import config from "./config";
import { accessToken } from "./shared/constants/localstorage.constant";
import { apiVersion } from "./shared/constants/common.constant";

//The translation namespaces that the application uses.
const namespace = [
  "common",
  "profile",
  "aml",
  "audits",
  "monitor",
  "reports",
  "settings",
];

const decideLoadPath = (isUpp: boolean | undefined): string => {
  let loadPath: string;

  if (config.IS_lOCIZE_ENABLED) {
    loadPath = `${config.COMPLIANCE_API_URL}/${apiVersion}/i18next?version=latest&namespace={{ns}}&locale={{lng}}`;
  } else if (isUpp) {
    // Load translations from the express server
    loadPath = `http://localhost:5555/i18n/{{ns}}/{{lng}}.translation.json`;
  } else {
    loadPath = `/locales/{{ns}}/{{lng}}.translation.json`;
  }

  return loadPath;
};

const initI18nClient = async (isUpp: boolean | undefined): Promise<void> => {
  i18n.use(LanguageDetector).use(ChainedBackend).use(initReactI18next);

  const backendOptions = {
    backends: [HttpBackend, HttpBackend],
    //if compliance end point fails set default fallback as public path
    backendOptions: [
      {
        loadPath: decideLoadPath(isUpp),
        customHeaders: {
          authorization: `Bearer ${localStorage.getItem(accessToken)}`,
        },
      },
      {
        loadPath: "/locales/{{ns}}/{{lng}}.translation.json",
      },
    ],
  };

  if (!i18n.isInitialized) {
    await i18n.init({
      fallbackLng: "en-GB",
      saveMissing: false,
      load: "currentOnly",
      ns: namespace,
      defaultNS: "profile",
      lng: "en-GB",
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: true,
      },
      ...{ backend: backendOptions },
      debug: true,
    });
  }
};

export { initI18nClient };

export default i18n;
